(() => {
  angular.module('finance').component('organizationUtilizationInvoiceDetailDetailedChargesComponent', {
    templateUrl: require('./organizationUtilizationDetailedCharges.component.html'),
    controller: OrganizationUtilizationInvoiceDetailDetailedChargesComponent,
    controllerAs: 'vm',
    bindings: {
      invoice: '<',
      getDateString: '<'
    },
  });

  OrganizationUtilizationInvoiceDetailDetailedChargesComponent.$inject = [];

  function OrganizationUtilizationInvoiceDetailDetailedChargesComponent() {
    const vm = this;

    vm.loading = 0;
    vm.isDate = function(item) {
      return App.isDate(item);
    };

    init();

    function init() {}
  }
})();
